import { render, staticRenderFns } from "./table.vue?vue&type=template&id=5a23d350&scoped=true"
import script from "./table.vue?vue&type=script&lang=js"
export * from "./table.vue?vue&type=script&lang=js"
import style0 from "./table.vue?vue&type=style&index=0&id=5a23d350&prod&lang=scss&scoped=true"
import style1 from "./table.vue?vue&type=style&index=1&id=5a23d350&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5a23d350",
  null
  
)

export default component.exports